var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "d-flex justify-content-center align-items-center w-100" },
      [
        _c(
          "div",
          { staticClass: "spinner-border", attrs: { role: "status" } },
          [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }